if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.preventVariantURLSwitching();
          super.show(opener);
          
          //Init Gallery Flickity Slider
          function productGallerySlider(){
            waitForElement('.product__media-list[data-flickity]', function (e) {
              
              const gallerySlider = document.querySelector('quick-add-modal[open] .product__media-list[data-flickity]');
              if(gallerySlider){
                var galleryAttributes = gallerySlider.dataset.flickity;
                const galleryAttributesJSON = JSON.parse(galleryAttributes);
                var newGallerySlider = new Flickity(gallerySlider,galleryAttributesJSON);
                setTimeout(function(e){
                  newGallerySlider.resize();
                  
                    /*var gallertDots = document.querySelectorAll('quick-add-modal[open] .product__media-list[data-flickity] .flickity-page-dots .dot');
                    for(let i=0;i<gallertDots.length;i++){
                      gallertDots[i].addEventListener('click',function(e){
                        var slide_index = this.getAttribute('aria-label');
                       slide_index = slide_index.replace('Page dot ','');
                       alert(slide_index-1);
                        var newMainSlider = new Flickity('quick-add-modal[open] .product__media-list.flickity-enabled');
                        newMainSlider.select(slide_index-1);
                      });
                    }*/
                },100);
              }
              
              const thumbnailSlider = document.querySelector('quick-add-modal[open] .thumbnail-list[data-flickity]');
              if(thumbnailSlider){
                var thumbnailAttributes = thumbnailSlider.dataset.flickity;
                const thumbnailAttributesJSON = JSON.parse(thumbnailAttributes);
                var newThumbnailSlider = new Flickity(thumbnailSlider,thumbnailAttributesJSON);
                setTimeout(function(e){
                  newThumbnailSlider.resize();
                },100);
              }
            });
          }
          productGallerySlider();
          //defaultVariant();
          function defaultVariant(){
            waitForElement('.product-form__input input[name="Size"]', function (e) {
              const defaultSize = document.querySelector('.product-form__input input[name="Size"][value="12oz"]');
              if(defaultSize){
                setTimeout(function(e){
                  defaultSize.click();
                },1000)
              }
            });
          }
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      this.modalContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      // galleryList.setAttribute('role', 'presentation');
      // galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }
  });
}
